'use strict';

(() => {
  
  const ICON_CONFIG = [
    {
      selector: 'a.link[data-has_link_with_icon="arrow-right-sm"]:not(.button--collection-all-products)',
      iconId: 'icon-arrow-right-sm',
      position: 'beforeend',
      className: 'arrow-right-sm',
      width: 20,
      height: 20
    }
  ];
  
  const PROCESSED_ATTR = 'data-icon-processed';
  
  function createIcon(iconId, className, defWidth, defHeight) {
    const svgSource = document.getElementById(iconId);
    if (!svgSource) {
      console.warn(`Icon with ID #${iconId} not found in DOM.`);
      return null;
    }
    const width = svgSource?.getAttribute('width') || defWidth;
    const height = svgSource?.getAttribute('height') || defHeight;
  
    return `<svg class="icon-svg ${className}" width="${width}" height="${height}" 
      aria-hidden="true"><use href="#${iconId}"></use></svg>`.trim();
  }
  
  function injectIcons(container = document) {
    if (!container.querySelectorAll) return;
  
    ICON_CONFIG.forEach(({ selector, iconId, position, className, width, height }) => {
      const elements = container.querySelectorAll(`${selector}:not([${PROCESSED_ATTR}])`);
  
      elements.forEach((element) => {
        const iconHTML = createIcon(iconId, className, width, height);
        if (!iconHTML) return;
        element.insertAdjacentHTML(position, iconHTML);
        element.setAttribute(PROCESSED_ATTR, 'true');
      });
    });
  }
  
  function initIconObserver() {
    injectIcons();
  
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            injectIcons(node);
          }
        });
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIconObserver);
  } else {
    initIconObserver();
  }
  
  ['shopify:section:load', 'shopify:section:reorder'].forEach(event => {
    document.addEventListener(event, (e) => {
      if (e.target instanceof Element) injectIcons(e.target);
    });
  });

})();